<template>
  <div class="observaciones">
    <input-comp label="Observaciones" v-model="observacion"/>
  </div>
</template>

<script>
  import InputComp from "../../../../Componentes_Globales/Input/inputComp";

  export default {
    name: "Observacion",
    components: {InputComp},
    computed: {
      observacion: {
        get() {
          return this.$store.state.producto.producto.observacion
        },
        set(value) {
          this.$store.commit("producto/SET_KEY_PRODUCTO", {key: "observacion", value})
        }
      }
    }
  }
</script>

<style scoped>

</style>
